<app-loader *ngIf="successActionLoading"></app-loader>
<div class="modal__header">
  <span class="title">{{ title }}</span>
  <div class="modal-close color-gray-dark" id="appCloseXConfirm" (click)="activeModal.dismiss()"></div>
</div>
<div class="modal__body">
  <div [innerHTML]="description"></div>

  <div class="mt-16" *ngIf="errorMessage">
    <app-message [type]="'error'">
      <div message-content>
        {{ errorMessage }}
      </div>
    </app-message>
  </div>
</div>
<div class="modal__footer" *ngIf="successButtonName">
  <div class="modal__footer-action">
    <button class="button" type="button" (click)="successAction()" id="appSuccessConfirm1" [disabled]="isBlockedFixed" *ngIf="successCallbackAction">
      {{ successButtonName }}
    </button>
  </div>
  <div class="modal__footer-action" *ngIf="abortButtonName">
    <a class="link link--dotted-blue-dark" id="appCloseConfirm" (click)="activeModal.dismiss()">
      {{ abortButtonName }}
    </a>
  </div>
</div>
